import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import moment from "moment/moment";
//internal import
import TaskServices from "../services/TaskServices";
import { notifyError, notifySuccess } from "../utils/toast";
import { allContext } from "../context/AllContext";

const useTaskSubmit = (id) => {
  const [viewData, setviewData] = useState([]);
  const [isViewModal, setIsViewModal] = useState(false);
  const { dataUpdate, setDataUpdate } = useContext(allContext);
  const [isModal, setIsModal] = useState(false);
  const [isDeleteModal, setIsDeleteModal] = useState(false);
  const [startDatemandetory, setStartDatemandetory] = useState("");

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm();


  const onSubmit = async (taskData) => {
    try {

      if (taskData.taskStatus === "Open") {
        taskData.taskStartDate = "";
        taskData.taskEndDate = "";
      }
      if (taskData?.taskStatus !== "Open" && !taskData?.taskStartDate) {
        notifyError(`Task Start Date is Required!`);
        return;
      }
      if (taskData?.taskStatus === "Completed") {
        if (!taskData?.taskEndDate) {
          notifyError(`Task End Date is Required!`);
          return;
        }
      }
      else {
        taskData.taskEndDate = "";
      }
      taskData.completedDate = taskData.taskEndDate;
      if (id) {
        const res = await TaskServices.updateTask(id, taskData);
        setIsModal(false);
        notifySuccess(res.message);
        setDataUpdate(!dataUpdate);
      } else {
        const res = await TaskServices.addTask(taskData);
        setIsModal(false);
        notifySuccess(res.message);
        setDataUpdate(!dataUpdate);
      }
      reset();
      return;
    } catch (err) {
      notifyError(err ? err?.response?.data?.message : err?.message);
    }
  };

  const deleteTask = async (taskID) => {
    const result = await TaskServices.deleteTask(taskID);
    notifySuccess(result.message);
    setIsDeleteModal(false);
    setDataUpdate(!dataUpdate);
  }

  const ShowEditValues = async (row, type) => {
    const result = await TaskServices.getTaskById(row._id);
    if (result?.success === true) {
      if (type === "Edit") {
        var editres = result?.data;
        setValue("projectId", editres?.projectId?._id);
        setValue("projectModule", editres?.projectModule);
        setValue("tasks.0", editres?.tasks[0]);
        setValue("description", editres?.description);
        setValue("taskStartDate", editres?.taskStartDate ? moment.utc(editres?.taskStartDate).format("YYYY-MM-DD HH:mm") : "");
        setValue("taskEndDate", editres?.completedDate ? moment.utc(editres?.completedDate).format("YYYY-MM-DD HH:mm") : "");
        setValue("assignPerson", editres?.assignPerson?._id);
        setValue("priority", editres?.priority);
        setValue("taskStatus", editres?.taskStatus);
        setStartDatemandetory(editres?.taskStatus);
      }
      setviewData(result?.data);
    }
  }

  useEffect(() => {
    // console.log(" id == ", id);
    if (!id) {
      setValue("projectId", "");
      setValue("projectModule", "");
      setValue("tasks.0", "");
      setValue("description", "");
      setValue("taskStartDate", "");
      setValue("taskEndDate", "");
      setValue("assignPerson", "");
      setValue("priority", "");
      setValue("taskStatus", "");
      setValue("taskStatus", "Open");
      setStartDatemandetory("");
    }
  }, [id])

  return {
    register,
    handleSubmit,
    onSubmit,
    errors,
    setviewData,
    viewData,
    deleteTask,
    ShowEditValues,
    isViewModal, setIsViewModal,
    isModal, setIsModal,
    isDeleteModal, setIsDeleteModal,
    startDatemandetory, setStartDatemandetory,
    reset
  };
};

export default useTaskSubmit;
